import { render, staticRenderFns } from "./WHBrands.vue?vue&type=template&id=baa73714&"
import script from "./WHBrands.vue?vue&type=script&lang=js&"
export * from "./WHBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports